import gql from 'graphql-tag';

export default gql`
  mutation transformSuggestionsListToShoppingCart($suggestionsListId: ID!) {
    transformSuggestionsListToShoppingCart(
      suggestionsListId: $suggestionsListId
    )
  }
`;
